import React from "react";

function Header({ title, darkMode, setDarkMode, isLoggedIn, logout }) {
  return (
    <div
      style={{
        background: darkMode ? "#1e1e1e" : "#333",
        color: "#fff",
        padding: "15px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <h3 style={{ margin: 0 }}>{title}</h3>

      <div>
        {/* 🌙 DARK MODE BUTTON */}
        <button
          onClick={() => setDarkMode(!darkMode)}
          style={{
            marginRight: "15px",
            padding: "6px 10px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          {darkMode ? "☀ Light" : "🌙 Dark"}
        </button>

        {/* 🔐 AUTH BUTTONS */}
        {!isLoggedIn ? (
          <>
            <a
              href="/"
              style={{ color: "#fff", marginRight: "15px", textDecoration: "none" }}
            >
              Login
            </a>
            <a
              href="/register"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Register
            </a>
          </>
        ) : (
          <button
            onClick={logout}
            style={{
              background: "red",
              color: "#fff",
              border: "none",
              padding: "6px 12px",
              borderRadius: "5px",
              cursor: "pointer"
            }}
          >
            Logout
          </button>
        )}
      </div>
    </div>
  );
}

export default Header;